import { CustomizacaoSubmenuEnum } from "src/app/shared/enums/CustomizacaoSubmenuEnum";
import { Component, OnInit } from "@angular/core";
import { ParametrosDataService } from "src/app/services/parametros-data.service";
import { Router } from "@angular/router";
import { ParametrosKey } from "src/app/shared/enums/parametros.enum";

@Component({
    selector: "app-unidade",
    templateUrl: "./unidade.component.html"
})
export class UnidadeComponent implements OnInit {
    constructor(
        private router: Router,
        private parametrosDataService: ParametrosDataService
    ) {}

    ngOnInit() {
        const canAccess = this.parametrosDataService.ShowSubmenu(
            CustomizacaoSubmenuEnum.unidades
        );

        if (!canAccess) {
            this.router.navigate(["accessdenied"]);
        }
    }
}
